import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotifierService } from 'src/app/services/notifier.service';
import { ActivatedRoute } from '@angular/router';
import { APIService } from 'src/app/services/api.service';

import { getENV } from 'src/app/_helpers/helpers';

export interface AnimalDetail {
  AnimalId: string;
  RaceState: string;
}

export interface RaceInterface {
  ExternalEventId: string;
  ExternalVenueId: string;
  ExternalRaceId: string;
  SquentialRaceOrderNumber: number;
  RaceName: string;
  RaceTime: string;
  RaceLength: string;
  Track: string;
  TrackType: string;
  StartType: string;
  AnimalDetail: AnimalDetail[];
  standardTimeMessage: any[]; // You can define a more specific type if needed.
}

export interface DialogData {
  venueid: string;
  tracks: any[];
  racelengths: any[];
  races: RaceInterface[];
  rail_position: string;
  rail_start: string;
  rail_end: string;
  remainder: string;
  transition: string;
  entire_course_rail: string;
  externalEventId: string;
}

export interface apiEQTrack {
  RaceLength: string;
  EQTrackName: string;
  TrackID: string;
  AdditionalStart: string;
  TrackType: string;
  TrackLength: string;
}

@Component({
  selector: 'rail_calculator',
  templateUrl: 'rail-calculator.component.html',
  styleUrls: ['rail-calculator.component.css'],
})
export class rail_dialog implements OnInit {
  @Input('data') data: any;
  @Output('hideModel') hideModel: any = new EventEmitter<boolean>();
  selectedOption: string = 'entireCourse';
  generating: boolean = false;
  entireCourseDetails: number = 0;
  splitDetails1: number = 0;
  splitDetails2: number = 0;
  splitDetails3: number = 0;
  splitDetails4: number = 0;
  splitDetails5: number = 0;
  errorMessage: string = '';
  trackLengths: any[] = [];
  tableResult: any[] = [];
  tracker: any[] = [];
  apiKey = 'e2bvuAoslY1VJvFMqhr5x7nxoEhFVRii9jRngS3U';
  isButtonDisabled: boolean = false;
  config: any;
  constructor(
    private router: ActivatedRoute,
    private notifier: NotifierService,
    private apiService: APIService
  ) { }

  async ngOnInit(): Promise<void> {
    this.config = this.router.snapshot.data['config'];
    // Convert input data to numbers
    this.splitDetails1 = Number(this.data.rail_position) || 0;
    this.splitDetails2 = Number(this.data.rail_start) || 0;
    this.splitDetails3 = Number(this.data.rail_end) || 0;
    this.splitDetails4 = Number(this.data.remainder) || 0;
    this.splitDetails5 = Number(this.data.transition) || 150;

    if(this.data.custom_split == 'True Entire Circuit') {
      this.entireCourseDetails = 0;
    } else {
      this.entireCourseDetails = Number(this.data.entire_course_rail) || 0;
    }

    if (this.splitDetails1 !== 0) {
      this.selectedOption = 'split';
    } else {
      this.selectedOption = 'entireCourse';
    }

    if (this.entireCourseDetails !== null || !isNaN(this.splitDetails5)) {
      await this.fetchRailPositions();
      if(this.splitDetails5 === 150) {
        this.onSplitDetails5Change();
      }
    } else {
      this.entireCourseDetails = 0;
    }
  }

  onNoClick(): void {
    this.isButtonDisabled = false;
    this.hideModel.emit(false);
  }

  validateNumericInput(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 46 || charCode == 45) {
      // Allow decimal point and minus sign
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      // Block non-numeric characters
      return false;
    }
    return true;
  }

  validateInputs(): boolean {
    if (this.selectedOption === 'entireCourse') {
      if (this.entireCourseDetails === null || this.entireCourseDetails === undefined) {
        this.errorMessage = 'Entire course rail position cannot be empty';
        return false;
      }
    } else {
      if (this.splitDetails1 === null || this.splitDetails1 === undefined) {
        this.errorMessage = 'Rail position cannot be empty';
        return false;
      }
      if (this.splitDetails2 === null || this.splitDetails2 === undefined) {
        this.errorMessage = 'Split start cannot be empty';
        return false;
      }
      if (this.splitDetails3 === null || this.splitDetails3 === undefined) {
        this.errorMessage = 'Split end cannot be empty';
        return false;
      }
      if (this.splitDetails4 === null || this.splitDetails4 === undefined) {
        this.errorMessage = 'Remainder cannot be empty';
        return false;
      }
      // Updated transition validation for number type
      if (!this.splitDetails5) {
        this.splitDetails5 = 150;
      }
    }
    return true;
  }

  async onGenerate(): Promise<void> {
    this.errorMessage = '';

    if (!this.validateInputs()) {
      return;
    }

    // Ensure splitDetails5 is 150 if not set
    if (!this.splitDetails5) {
      this.splitDetails5 = 150;
    }

    // Proceed with generating the table
    this.generating = true;
    this.tableResult = [];
    const apiUrl = `${this.config[getENV()].raceAPI}/geteqtrack?ExternalVenueId=${this.data.venueid}`;
    const apiKey = 'e2bvuAoslY1VJvFMqhr5x7nxoEhFVRii9jRngS3U';
    this.trackLengths = [];
    const headers: any = {
      accept: 'application/json',
      'x-api-key': apiKey,
    };

    const data: any = await this.apiService.getDataPromis(apiUrl, {}, headers);

    if (data && data.venue) {
      let tracklist = data.venue.TrackList;
      const resultArray = this.data.races
        .map((race: RaceInterface) => {
          const trackKey =
            `eqt_trace_track_${race.ExternalRaceId}` as keyof typeof this.data.tracks;
          const trackValue = this.data.tracks[trackKey];
          return { EQTrackName: trackValue };
        })
        .filter((item) => item !== null);

      resultArray.forEach((item: { EQTrackName: any }) => {
        if (item['EQTrackName'] === null) {
          this.generating = false;
          this.errorMessage = 'Missing EQTrack! Please submit it!';
          return;
        }
      });
      resultArray.forEach((item: { EQTrackName: any }) => {
        let shouldContinue = false;
        tracklist.forEach((trackname: apiEQTrack) => {
          if (trackname.EQTrackName === item.EQTrackName) {
            if (trackname.TrackLength === null) {
              this.errorMessage =
                'Missing TrackLength! Let Carl to add them in!';
            }
            if (trackname.TrackLength && !shouldContinue) {
              this.trackLengths.push([
                trackname.TrackLength,
                trackname.AdditionalStart,
                trackname.TrackType,
                trackname.RaceLength
              ]);
              shouldContinue = true;
              return;
            }
          }
        });

        if (shouldContinue) {
          return;
        }
      });
    }
    if (this.selectedOption === 'split') {
      this.trackLengths.forEach((item, index) => {
        const raceLength = this.data.racelengths[index];
        const startingPos = Math.max(
          Number(item[0]),
          Number(raceLength)
        );
        const pushing: any[] = [];
        let lowerItem = item[2].toLowerCase();
        if (!lowerItem.includes('turf')) {
          pushing.push({
            add: 0,
            start: Number(item[0]),
            end: 0,
            transition: 0,
          });
        } else {
          var newstart: number = 0;
          if (Number(raceLength) - Number(item[0]) > 0) {
            if (this.splitDetails3 !== 0) {
              if (Number(item[0]) >= this.splitDetails2) {
                pushing.push({
                  add: this.splitDetails4,
                  start: newstart === 0 ? Number(item[0]) : newstart,
                  end: this.splitDetails2 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
                pushing.push({
                  add: this.splitDetails1,
                  start: this.splitDetails2 + this.splitDetails5 / 2,
                  end: this.splitDetails3 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
              } else {
                pushing.push({
                  add: this.splitDetails1,
                  start: newstart === 0 ? Number(item[0]) : newstart,
                  end: this.splitDetails3 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
              }
              pushing.push({
                add: this.splitDetails4,
                start: this.splitDetails3 + this.splitDetails5 / 2,
                end: 0,
                transition: 0,
              });
            } else {
              if (Number(item[0]) >= this.splitDetails2) {
                pushing.push({
                  add: this.splitDetails1,
                  start: newstart === 0 ? Number(item[0]) : newstart,
                  end: Number(item[0]) - this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
                pushing.push({
                  add: this.splitDetails4,
                  start: Number(item[0]) - this.splitDetails5 / 2,
                  end: this.splitDetails2 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
                pushing.push({
                  add: this.splitDetails1,
                  start: this.splitDetails2 + this.splitDetails5 / 2,
                  end: 0,
                  transition: 0,
                });
              } else {
                pushing.push({
                  add: this.splitDetails1,
                  start: newstart === 0 ? Number(item[0]) : newstart,
                  end: 0,
                  transition: 0,
                });
              }
            }
          } else {
            if (this.splitDetails3 !== 0) {
              if (Number(item[0]) >= this.splitDetails2) {
                pushing.push({
                  add: this.splitDetails4,
                  start: startingPos,
                  end: this.splitDetails2 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
                pushing.push({
                  add: this.splitDetails1,
                  start: this.splitDetails2 + this.splitDetails5 / 2,
                  end: this.splitDetails3 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
              } else {
                pushing.push({
                  add: this.splitDetails1,
                  start: startingPos,
                  end: this.splitDetails3 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
              }
              pushing.push({
                add: this.splitDetails4,
                start: this.splitDetails3 + this.splitDetails5 / 2,
                end: 0,
                transition: 0,
              });
            } else {
              if (Number(item[0]) >= this.splitDetails2) {
                pushing.push({
                  add: this.splitDetails4,
                  start: startingPos,
                  end: this.splitDetails2 + this.splitDetails5 / 2,
                  transition: this.splitDetails5,
                });
                pushing.push({
                  add: this.splitDetails1,
                  start: this.splitDetails2 + this.splitDetails5 / 2,
                  end: 0,
                  transition: 0,
                });
              } else {
                pushing.push({
                  add: this.splitDetails1,
                  start: startingPos,
                  end: 0,
                  transition: 0,
                });
              }
            }
          }
        }
        this.tableResult.push(pushing);
      });
    } else if (this.selectedOption === 'entireCourse') {
      this.trackLengths.forEach((item, index) => {
        const raceLength = item[0];
        let lowerItem = item[2].toLowerCase();
        const raceLengthTrack: string = Number(item[3]).toFixed(1);
        if (!lowerItem.includes('turf')) {
          this.tableResult.push([
            {
              add: 0,
              start: Number(item[0]),
              end: 0,
              transition: 0,
            },
          ]);
        } else if (this.data.venueid === '83' && raceLengthTrack === '2000.0') {
          // Specific logic for Caulfield 2000m race length
          this.tableResult.push([
            {
              add: Number(this.entireCourseDetails),
              start: 2150,
              end: 1450,
              transition: 200,
            },
            {
              add: 0,
              start: 1450,
              end: 1060,
              transition: 200,
            },
            {
              add: Number(this.entireCourseDetails),
              start: 1060,
              end: 0,
              transition: 0,
            },
          ]);
        } else if (this.data.venueid === '151' && (raceLengthTrack === '1400.0' || raceLengthTrack === '1600.0') && Number(this.entireCourseDetails) > 5) {
          // Specific logic for Flemington 1400m and 1600m race lengths
          this.tableResult.push([
            {
              add: 5,
              start: Number(raceLength),
              end: Number(raceLengthTrack) - 100,
              transition: 100,
            },
            {
              add: Number(this.entireCourseDetails),
              start: Number(raceLengthTrack) - 100,
              end: 0,
              transition: 0,
            },
          ]);
        } else {
          this.tableResult.push([
            {
              add: Number(this.entireCourseDetails),
              start: Math.max(Number(item[0]), Number(raceLength)),
              end: 0,
              transition: 0,
            },
          ]);
        }
      });
    }
  }
  async fetchTracks(): Promise<void> {
    this.generating = true;

    const apiUrl = `${this.config[getENV()].raceAPI}/geteqtrack?ExternalVenueId=${this.data.venueid}`;
    const apiKey = 'e2bvuAoslY1VJvFMqhr5x7nxoEhFVRii9jRngS3U';

    const headers: any = {
      'x-api-key': apiKey,
      'Content-Type': 'application/json',
    };

    const data: any = await this.apiService.getDataPromis(apiUrl, {}, headers);
    if (data && data.venue) {
      let tracklist = data.venue.TrackList;
      const resultArray = this.data.races
        .map((race: RaceInterface) => {
          const trackKey =
            `eqt_trace_track_${race.ExternalRaceId}` as keyof typeof this.data.tracks;
          const trackValue = this.data.tracks[trackKey];
          return { EQTrackName: trackValue };
        })
        .filter((item) => item !== null);

      resultArray.forEach((item: { EQTrackName: any }) => {
        if (item['EQTrackName'] === null) {
          this.generating = false;
          this.errorMessage = 'Missing EQTrack! Please submit it!';
          return;
        }
      });
      resultArray.forEach((item: { EQTrackName: any }) => {
        let shouldContinue = false;
        tracklist.forEach((trackname: apiEQTrack) => {
          if (trackname.EQTrackName === item.EQTrackName) {
            if (trackname.TrackLength === null) {
              this.errorMessage =
                'Missing TrackLength! Let Carl to add them in!';
            }
            if (trackname.TrackLength && !shouldContinue) {
              this.trackLengths.push([
                trackname.TrackLength,
                trackname.AdditionalStart,
                trackname.TrackType,
                trackname.RaceLength,
              ]);
              shouldContinue = true;
              return;
            }
          }
        });

        if (shouldContinue) {
          return;
        }
      });
    }
  }

  onSplitDetails5Change() {
    // Ensure default value of 150 if empty or invalid
    if (!this.splitDetails5 || isNaN(this.splitDetails5)) {
      this.splitDetails5 = 150;
    }

    this.tableResult.forEach((tracker: any) => {
      tracker.forEach((track: any) => {
        track.transition = this.splitDetails5;
      });
    });
  }

  async fetchRailPositions(): Promise<void> {
    this.notifier.loading(true);
    this.generating = true;
    this.tableResult = [];
    await this.fetchTracks();

    const haaders: any = {
      'x-api-key': this.apiKey,
      'Content-Type': 'application/json',
    };

    const apiURL: string = `${this.config[getENV()].raceAPI}/railpositiondatamessage?ExternalEventId=${this.data.externalEventId}`;

    try {
      const response: any = await this.apiService.getDataPromis(
        apiURL,
        {},
        haaders
      );

      // Process the response here, ensuring proper type conversion from string to number
      this.tableResult = this.data.races.map((race) => {
        const raceRailPositions = response['rail positions']
          .filter((rp: any) => rp.ExternalRaceID === race.ExternalRaceId)
          .map((rp: any) => ({
            add: Number(rp.RailShift || '0'),
            start: Number(rp.Start || '0'),
            end: Number(rp.End || '0'),
            transition: Number(rp.Transition || '150'),
          }));

        return raceRailPositions.length > 0
          ? raceRailPositions
          : [
              {
                add: 0,
                start: 0,
                end: 0,
                transition: 150,
              },
            ];
      });
    } catch (error) {
      console.error('Error fetching rail positions:', error);
    }
    this.notifier.loading(false);
  }

  validateTableInputs(): boolean {
    for (let i = 0; i < this.tableResult.length; i++) {
      for (let j = 0; j < this.tableResult[i].length; j++) {
        const track = this.tableResult[i][j];
        if (track.add === undefined || track.start === undefined ||
            track.end === undefined || track.transition === undefined) {
          this.errorMessage = `All fields in Race ${i + 1}, Row ${j + 1} must be filled`;
          return false;
        }
        // Ensure transition is 150 if not set
        if (!track.transition) {
          track.transition = 150;
        }
      }
    }
    return true;
  }

  async onSubmit() {
    // Ensure transition value is 150 if not set
    if (!this.splitDetails5) {
      this.splitDetails5 = 150;
    }

    if (!this.validateInputs() || !this.validateTableInputs()) {
      return;
    }

    if (this.selectedOption === 'entireCourse') {
      this.splitDetails1 = 0;
      this.splitDetails2 = 0;
      this.splitDetails3 = 0;
      this.splitDetails4 = 0;
      this.splitDetails5 = 0;
    } else if (this.selectedOption === 'split') {
      this.entireCourseDetails = null;
    }

    const races = this.data.races;
    let event_update = {
      Rail: this.splitDetails1.toString(),
      RailStart: this.splitDetails2.toString(),
      RailEnd: this.splitDetails3.toString(),
      Remainder: this.splitDetails4.toString(),
      Transition: this.splitDetails5.toString(),
      EntireCourseRail: this.selectedOption === 'entireCourse' ? (this.entireCourseDetails || 0).toString() : '',
      RailUpdate: null,
      ExternalEventID: this.data.externalEventId,
    };

    let rail_update: any = [];
    races.forEach((item: RaceInterface, index: number) => {
      this.tableResult[index].forEach((rail_information: any) => {
        rail_update.push({
          ExternalRaceId: item.ExternalRaceId || '0',
          Additional: (rail_information.add || 0).toString(),
          Start: (rail_information.start || 0).toString(),
          End: (rail_information.end || 0).toString(),
          Transition: (rail_information.transition || 0).toString(),
        });
      });
    });
    event_update['RailUpdate'] = rail_update;

    const headers: any = {
      'Content-Type': 'application/json',
    };
    this.notifier.loading(true);
    const apiUrl = `${this.config[getENV()].raceAPI}/update-rail`;
    let result: any = await this.apiService.postDataPromis(
      apiUrl,
      event_update,
      headers
    );
    if (typeof result == 'string') {
      this.notifier.alert(
        'Info',
        '',
        result,
        'info',
        5000
      );
    } else if (result.success) {
      this.hideModel.emit(true);
      this.notifier.alert(
        'Success',
        '',
        'Rail data saved successfully',
        'success',
        5000
      );
    }
    this.notifier.loading(false);
  }
  addRow(trackerIndex: number): void {
    const newRow = {
      add: 0,
      start: 0,
      end: 0,
      transition: 150  // Default transition value
    };
    this.tableResult[trackerIndex].push(newRow);
  }

  deleteRow(trackerIndex: number, rowIndex: number): void {
    this.tableResult[trackerIndex].splice(rowIndex, 1);
  }

  updateSelection(): void {
    // Reset error message when selection changes
    this.errorMessage = '';
    // Reset table results when changing selection
    this.tableResult = [];
    this.generating = false;
  }

  getErrorType(): string {
    if (!this.errorMessage) return '';

    if (this.errorMessage.toLowerCase().includes('missing') ||
        this.errorMessage.toLowerCase().includes('cannot be empty')) {
      return 'error';
    }
    if (this.errorMessage.toLowerCase().includes('warning')) {
      return 'warning';
    }
    return 'info';
  }

  clearError(): void {
    this.errorMessage = '';
  }

  hasAssignedTracks(): boolean {
    if (!this.data || !this.data.races || !this.data.tracks) {
      return false;
    }

    return this.data.races.every((race) => {
      const trackKey = `eqt_trace_track_${race.ExternalRaceId}` as keyof typeof this.data.tracks;
      return this.data.tracks[trackKey] !== null && this.data.tracks[trackKey] !== undefined;
    });
  }
  getRailPositionPreview(): string {
    if (this.selectedOption === 'split' && this.splitDetails1) {
      const splitEnd = this.splitDetails3 === 0 ? 'W/Post' : `${this.splitDetails3}m`;
      const remainder = this.splitDetails4 === 0 ? 'True Remainder' : `+${this.splitDetails4}m`;
      return `+${this.splitDetails1}m ${this.splitDetails2}m-${splitEnd}, ${remainder}`;
    } else if (this.selectedOption === 'entireCourse') {
      // Check if it's 0m for True Entire Circuit
      if (this.entireCourseDetails === 0) {
        return 'True Entire Circuit';
      } else if (this.entireCourseDetails) {
        return `+${this.entireCourseDetails}m Entire`;
      }
    }
    return '';
  }

  isThouroughbredRace(raceType: string): boolean {
    return raceType?.toLowerCase().includes('thoroughbred');
  }

  formatRailPositionText(railPosition: number, raceType?: string): string {
    if (!this.isThouroughbredRace(raceType)) {
      return `${railPosition}m`;
    }

    if (railPosition === 0) {
      return 'True Entire Circuit';
    }
    return `+${railPosition}m Entire`;
  }
}
